/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 6170:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(11265);module.exports = "../../app/cells/components/banner/signup_banner/show.erb";

/***/ }),

/***/ 40158:
/***/ ((module) => {

module.exports = "../../app/cells/components/banner/signup_banner_cell.rb";

/***/ }),

/***/ 79752:
/***/ ((module) => {

module.exports = "../../app/cells/components/campaigns/interventions/leaderboard/show.erb";

/***/ }),

/***/ 53:
/***/ ((module) => {

module.exports = "../../app/cells/components/campaigns/interventions/leaderboard_cell.rb";

/***/ }),

/***/ 51036:
/***/ ((module) => {

module.exports = "../../app/cells/components/handle_title_segment/show.erb";

/***/ }),

/***/ 27310:
/***/ ((module) => {

module.exports = "../../app/cells/components/handle_title_segment_cell.rb";

/***/ }),

/***/ 54066:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(80888);module.exports = "../../app/cells/pages/disciplines/cta_discipline_list/show.erb";

/***/ }),

/***/ 49915:
/***/ ((module) => {

module.exports = "../../app/cells/pages/disciplines/cta_discipline_list_cell.rb";

/***/ }),

/***/ 11265:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"root":"LMdkPcjQFRlkuqTwWIOU","relative":"zwk5ILldSn2jMmPziZia","fixed":"PdCIKMUwTZJCRJcAd7dg","orange":"bDbB4ZveAnqHtZCa_spJ","black":"CHVpEcJJ1zSK9cIuafKQ","close":"xJZm4F7Au4HMKkuUAAEE"});

/***/ }),

/***/ 41911:
/***/ (() => {

"use strict";
// extracted by mini-css-extract-plugin


/***/ }),

/***/ 80888:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"cta":"H1xQaHumwdoQJUrx2WOw","title-cta":"nnVVnto7uaSL86FdX2gT","titleCta":"nnVVnto7uaSL86FdX2gT","button-cta":"IVrwhyf7QP8XxfX34WKc","buttonCta":"IVrwhyf7QP8XxfX34WKc"});

/***/ }),

/***/ 16020:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";

// EXTERNAL MODULE: ./pages/disciplines/components/cta_discipline_list/index.erb
var cta_discipline_list = __webpack_require__(54066);
// EXTERNAL MODULE: ./pages/disciplines/components/cta_discipline_list/index.rb
var components_cta_discipline_list = __webpack_require__(49915);
;// CONCATENATED MODULE: ./pages/disciplines/components/cta_discipline_list/index.js



;// CONCATENATED MODULE: ./utils/filter_form/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./components/filter_form/desktop_toggle/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./components/filter_form/desktop_toggle/index.js

(function($) {
    'use strict';
    const $toggle = $('.js-filter-form-desktop-toggle-btn');
    const $toggleInput = $(`#${$toggle.attr('for')}`);
    $toggleInput.off('change').on('change', (e)=>{
        const data = $toggle.data();
        if (e.currentTarget.checked) {
            $toggle.find('span').html(data.openText);
            $toggle.removeClass('q-open');
        } else {
            $toggle.find('span').html(data.closeText);
            $toggle.addClass('q-open');
        }
    });
    $toggleInput.trigger('change');
})(window.jQuery);

;// CONCATENATED MODULE: ./components/filter_form/footer/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./components/filter_form/footer/index.js


;// CONCATENATED MODULE: ./components/filter_form/header/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./components/filter_form/header/index.js


;// CONCATENATED MODULE: ./components/filter_form/toggle/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./components/filter_form/toggle/index.js


// EXTERNAL MODULE: ./components/select/index.js + 9 modules
var components_select = __webpack_require__(86325);
;// CONCATENATED MODULE: ./styles/components/_input-groups.scss
// extracted by mini-css-extract-plugin

// EXTERNAL MODULE: ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/omit.js
var omit = __webpack_require__(34449);
var omit_default = /*#__PURE__*/__webpack_require__.n(omit);
// EXTERNAL MODULE: ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/uniq.js
var uniq = __webpack_require__(75211);
var uniq_default = /*#__PURE__*/__webpack_require__.n(uniq);
;// CONCATENATED MODULE: ./utils/form_data_parser/index.js


class FormDataParser {
    static _getDisplayText($elem) {
        const text = $elem.data('summary-display') || $elem.text() || $elem.val() || '';
        return text.toString().trim();
    }
    _getInputs() {
        this.$inputs = window.jQuery(this.inputSelector, this.$form);
    }
    _getDisplay($input) {
        const isSelect = $input.is('select');
        const isCheckbox = $input.is(':checkbox');
        const isRadio = $input.is(':radio');
        if (!isSelect && !isCheckbox && !isRadio) {
            return FormDataParser._getDisplayText($input);
        }
        if (isSelect) {
            return $input.find(':selected').toArray().map((option)=>FormDataParser._getDisplayText(window.jQuery(option)));
        }
        const display = this.$form.find(`[name="${$input.attr('name')}"]:checked`).toArray().map((input)=>FormDataParser._getDisplayText(window.jQuery(input)));
        return uniq_default()(display);
    }
    _getCheckedInputsByName(name) {
        return window.jQuery(`[name="${name}"]:checked`, this.$form);
    }
    removeEmpty($input, render = true) {
        const name = $input.attr('name');
        const value = $input.val();
        const item = this.summary[name];
        const display = this._getDisplay($input);
        if (!item) {
            return;
        }
        if (item.isCheckable && item.isMultiple) {
            const index = item.value.indexOf(value.toString());
            if (index > -1) {
                this.summary[name].value.splice(index, 1);
                this.summary[name].display = display;
                if (!this.summary[name].value.length) {
                    this.summary = omit_default()(this.summary, name);
                }
            }
        } else {
            this.summary = omit_default()(this.summary, name);
        }
        if (render) {
            this.render();
        }
    }
    change(element, render = true) {
        const $input = window.jQuery(element);
        const isCheckable = $input.is(':checkbox') || $input.is(':radio');
        const isCheckbox = $input.is(':checkbox');
        const isRadio = $input.is(':radio');
        const name = $input.attr('name');
        const isEmpty = !$input.val() || $input.val().toString().length <= 0;
        const isMultiple = $input.attr('multiple') !== undefined || $input.is(':checkbox');
        const hasKey = !!this.summary[name];
        const display = this._getDisplay($input);
        if (!hasKey && (!isCheckable && isEmpty || isCheckable && !$input.is(':checked'))) {
            if (render) {
                this.render();
            }
            return;
        }
        if ($input.is('[type=text], [type=search], textarea') && $input.attr('minlength') && Number($input.val().trim().length) < Number($input.attr('minlength'))) {
            return;
        }
        if (hasKey && $input.is('[type=text], [type=search], textarea') && (!$input.val() || $input.val().trim() === '')) {
            return this.removeEmpty($input, render);
        }
        if (hasKey && isCheckbox && !$input.is(':checked')) {
            return this.removeEmpty($input, render);
        }
        if (hasKey && isRadio && !this._getCheckedInputsByName(name).length) {
            return this.removeEmpty($input, render);
        }
        let value = $input.val();
        if (isMultiple && isCheckable) {
            value = this._getCheckedInputsByName(name).toArray().map((x)=>x.value.toString());
            value = uniq_default()(value);
        }
        this.summary[name] = {
            name: name,
            value: value,
            display: display,
            label: $input.data('summary-label'),
            isCheckable: isCheckable,
            isMultiple: isMultiple,
            isSelect: !!$input.is('select')
        };
        if (render) {
            this.render();
        }
    }
    constructor(formElement, options = {}){
        this.inputSelector = 'input:not([data-no-summary]), select:not([data-no-summary]), textarea:not([data-no-summary])';
        this.$form = window.jQuery(formElement);
        this.summary = {};
        this.options = options;
    }
}


;// CONCATENATED MODULE: ./utils/filter_form/options/track.js
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

class FilterFormTracker extends FormDataParser {
    parse() {
        return Object.keys(this.summary).reduce((prev, curr)=>{
            return _extends({}, prev, {
                [`Form Label: ${this.summary[curr].label}`]: this.summary[curr].display
            });
        }, {});
    }
    constructor($form){
        super($form);
        this.$inputs = window.jQuery(this.inputSelector, this.$form);
        this.$inputs.toArray().forEach((el)=>this.change(el, false));
    }
}


;// CONCATENATED MODULE: ./utils/query_string/index.js
class QueryString {
    static getQueryStringData(qs = null) {
        const uriSearch = qs || location.search;
        let str = decodeURIComponent(uriSearch);
        if (typeof str !== 'string') return {};
        str = str.trim().replace(/^\?/, '');
        if (!str) return {};
        return str.trim().split('&').reduce(function(ret, param) {
            const parts = param.replace(/\+/g, ' ').split('=');
            let key = parts[0];
            let val = parts[1];
            val = val === undefined ? null : val;
            if (ret[key] && Array.isArray(ret[key])) {
                const index = ret[key].indexOf(val);
                if (index < 0) ret[key].push(val);
            } else {
                if (key.indexOf('[]') > -1) ret[key] = [
                    val
                ];
                else ret[key] = val;
            }
            return ret;
        }, {});
    }
    static parseQueryStringData(obj) {
        return window.jQuery.param(obj);
    }
}


// EXTERNAL MODULE: ../../node_modules/.pnpm/pubsub-js@1.5.8/node_modules/pubsub-js/src/pubsub.js
var pubsub = __webpack_require__(82941);
var pubsub_default = /*#__PURE__*/__webpack_require__.n(pubsub);
;// CONCATENATED MODULE: ./utils/event_manager/index.js
// https://github.com/mroderick/PubSubJS

delete window.PubSub;
window.EventManager = (pubsub_default());
const EventManager = window.EventManager;

// EXTERNAL MODULE: ./utils/media_query/index.js
var media_query = __webpack_require__(28925);
;// CONCATENATED MODULE: ./utils/filter_form/index.js
function filter_form_extends() {
    filter_form_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return filter_form_extends.apply(this, arguments);
}












class FilterForm {
    bindAll() {
        if (this.track) {
            this.bindFormTracker();
        }
        this.bindFilterFormActions();
        this.bindFilterFormActionButtons();
        this.bindFilterFormToggle();
        this.bindFilterFormToggleButton();
        this.bindSelects();
    }
    bindSelects() {
        window.jQuery('.q-select-input', this.$form).each((i, el)=>{
            window.jQuery(el).qselect();
        });
    }
    bindFilterFormActions() {
        this.$form.on('change', 'input:not([data-no-summary])', ()=>this.toggleFilterFormActionButtons());
        EventManager.subscribe('autofillByQueryString.applied', ()=>this.toggleFilterFormActionButtons());
        window.jQuery(document).on('filterFormToggle', ()=>this.toggleFilterFormToggle());
    }
    bindFilterFormActionButtons() {
        this.toggleFilterFormActionButtons();
        window.jQuery('.js-btn-clean', this.$form).on('click', ()=>{
            this.$form.clearForm();
            return false;
        });
    }
    bindFormTracker() {
        this.$form.on('submit', ()=>{
            const { filterName } = this.$form.data();
            const data = new FilterFormTracker(this.$form).parse();
            if (!filterName || Object.keys(data).length === 0) {
                return;
            }
            const notHasFilterQuestions = filterName !== 'questions';
            UserTracker.emit('event', filter_form_extends({
                eventName: `${filterName} searched`,
                data
            }, notHasFilterQuestions && {
                except: [
                    'user'
                ]
            }));
        });
    }
    bindFilterFormToggle() {
        this.$toggle.on('change', ()=>{
            const checked = this.$toggle.is(':checked');
            if (checked) {
                window.jQuery('body').addClass('q-no-scroll');
            } else {
                window.jQuery('body').removeClass('q-no-scroll');
            }
        });
    }
    bindFilterFormToggleButton() {
        const $toggleButton = window.jQuery('.js-filter-form-toggle-btn');
        if ($toggleButton.length) {
            const text = this.areFiltersApplied() ? $toggleButton.data().activeText : $toggleButton.data().inactiveText;
            $toggleButton.find('span').html(text);
        }
        $toggleButton.on('click', ()=>window.jQuery('#filter-form-toggle').prop('checked', true));
    }
    areFiltersApplied() {
        const params = QueryString.getQueryStringData();
        const isFormNotEmpty = !!Object.keys(omit_default()(this.$form.serializeObject(), [
            'per_page'
        ])).length;
        const hasQueryParams = !!Object.keys(omit_default()(params, [
            'sort',
            'per_page'
        ])).length;
        return !!(isFormNotEmpty || hasQueryParams);
    }
    toggleFilterFormActionButtons() {
        window.jQuery('.js-filter-form-actions button', this.$form).not('.js-always-display').each((i, button)=>window.jQuery(button).attr('disabled', !this.areFiltersApplied()));
        this.$form.find('.js-filter-button').attr('disabled', !this.areFiltersApplied());
    }
    toggleFilterFormToggle() {
        if (media_query/* MediaQuery.is */.z.is('md')) {
            return;
        }
        this.$toggle.prop('checked', !this.$toggle.prop('checked')).trigger('change');
    }
    constructor($form, options){
        window.jQuery.event.special.filterFormToggle = {
            noBubble: false
        };
        this.$form = $form;
        this.track = options.track;
        this.$toggle = window.jQuery('.js-filter-form-toggle');
        this.bindAll();
    }
}
(function($1) {
    'use strict';
    if (!$1.fn.filterForm) {
        $1.fn.filterForm = function(options = {}) {
            const $form = $1(this);
            this.filterFormInstance = new FilterForm($form, options);
            return $form;
        };
    }
})(window.jQuery);

;// CONCATENATED MODULE: ./utils/autofill_by_query_string/index.js


class AutoFillByQueryString {
    static sanitizeKey(key) {
        return key.replace('[', '\\[').replace(']', '\\]');
    }
    static sanitizeValue(value) {
        return value.replace(/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g, '\\\\$&');
    }
    static fillInputs($form, key, value) {
        key = AutoFillByQueryString.sanitizeKey(key);
        const $input = window.jQuery(`[name="${key}"]`, $form).not('input[type="checkbox"], input[type="radio"], .q-select-input[data-ajax] input, [data-autofill="false"]');
        if (!$input.length) {
            return;
        }
        if ($input.is('select')) {
            $input.val(value);
            $input.find(`option[value="${AutoFillByQueryString.sanitizeValue(value)}"]`).prop('selected', true).trigger('change');
        } else {
            $input.val(value);
        }
        $input.trigger('change');
    }
    static fillCheckInputs($form, key, value) {
        key = AutoFillByQueryString.sanitizeKey(key);
        const apply = function(value) {
            window.jQuery(`[name="${key}"]`, $form).not('[data-autofill="false"]').each((i, el)=>{
                const $input = window.jQuery(el);
                if (($input.is(':checkbox') || $input.is(':radio')) && value === $input.val()) {
                    $input.prop('checked', true).attr('checked', true).trigger('change');
                }
            });
        };
        if (Array.isArray(value)) {
            window.jQuery(value).each((i, val)=>{
                apply(val);
            });
        } else {
            apply(value);
        }
    }
    static fillAjaxSelects($form, key, value) {
        key = AutoFillByQueryString.sanitizeKey(key);
        key = key.replace('\\[', '');
        key = key.replace('\\]', '');
        const $ajaxSelects = window.jQuery(`.q-select-input[data-ajax="true"][data-name="${key}"]:not([data-autofill="false"])`, $form);
        if ($ajaxSelects.length) {
            $ajaxSelects.each((i, select)=>{
                window.jQuery(select).qselect('setValue', value);
            });
        }
    }
}
(function($1) {
    'use strict';
    if (!$1.fn.autoFillByQueryString) {
        $1.fn.autoFillByQueryString = function(qs = null) {
            const $form = this;
            qs = $form.data('current-params') || qs;
            const data = QueryString.getQueryStringData(qs);
            Object.keys(data).forEach(function(key) {
                const value = data[key];
                AutoFillByQueryString.fillInputs($form, key, value);
                AutoFillByQueryString.fillCheckInputs($form, key, value);
                AutoFillByQueryString.fillAjaxSelects($form, key, value);
            });
            EventManager.publish('autofillByQueryString.applied', data);
            return $form;
        };
    }
})(window.jQuery);
/* harmony default export */ const autofill_by_query_string = ((/* unused pure expression or super */ null && (AutoFillByQueryString)));

;// CONCATENATED MODULE: ./components/alphabetical_input/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./components/alphabetical_input/index.js


;// CONCATENATED MODULE: ./pages/disciplines/components/discipline_filter_form/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./pages/disciplines/components/discipline_filter_form/index.js





(function($) {
    const $filterForm = $('#js-disciplines-filter-form');
    $filterForm.autoFillByQueryString().filterForm().lazyReady();
// $filterForm.on('submit', () => {
//   $filterForm.trigger('filterFormToggle');
//   return false;
// });
})(window.jQuery);

;// CONCATENATED MODULE: ./pages/disciplines/components/discipline_item/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./pages/disciplines/components/discipline_item/index.js


;// CONCATENATED MODULE: ./pages/disciplines/index.scss
// extracted by mini-css-extract-plugin

// EXTERNAL MODULE: ./components/banner/signup_banner/index.erb
var signup_banner = __webpack_require__(6170);
// EXTERNAL MODULE: ./components/banner/signup_banner/index.rb
var banner_signup_banner = __webpack_require__(40158);
;// CONCATENATED MODULE: ./components/banner/signup_banner/index.js
function signup_banner_extends() {
    signup_banner_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return signup_banner_extends.apply(this, arguments);
}


const SIGNUP_BANNER_EVENT = 'account created banner';
const SIGNUP_BANNER_EXCEPT = [
    'user',
    'iterable',
    'appcues'
];
class SignupBanner {
    init() {
        this.close.on('click', (e)=>window.jQuery(e.currentTarget).parent().hide());
        this.button.on('click', (e)=>{
            const button = window.jQuery(e.currentTarget);
            const isDataEmit = button.attr('data-emit') || false;
            const flag = button.attr('data-flag') || 'flag-default';
            const theme = button.attr('data-theme') || 'theme-default';
            const position = button.attr('data-position') || 'position-default';
            if (isDataEmit) {
                this.dispatchTrackerEvent('clicked', {
                    flag,
                    theme,
                    position
                });
            }
        });
    }
    dispatchTrackerEvent(event, params = {}) {
        const data = {
            eventName: `${SIGNUP_BANNER_EVENT} ${event}`,
            except: SIGNUP_BANNER_EXCEPT,
            data: signup_banner_extends({}, params)
        };
        try {
            UserTracker.emit('event', data);
        } catch (error) {
            Rollbar.error('dispatchTrackerEvent', error);
        }
    }
    constructor(){
        this.close = window.jQuery('#js-signup-banner-close');
        this.button = window.jQuery('#js-signup-banner');
    }
}
(()=>{
    new SignupBanner().init();
})();

// EXTERNAL MODULE: ./components/campaigns/interventions/leaderboard/index.erb
var leaderboard = __webpack_require__(79752);
// EXTERNAL MODULE: ./components/campaigns/interventions/leaderboard/index.rb
var interventions_leaderboard = __webpack_require__(53);
;// CONCATENATED MODULE: ./components/campaigns/interventions/leaderboard/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./components/campaigns/interventions/leaderboard/index.js




// EXTERNAL MODULE: ./components/handle_title_segment/index.erb
var handle_title_segment = __webpack_require__(51036);
// EXTERNAL MODULE: ./components/handle_title_segment/index.rb
var components_handle_title_segment = __webpack_require__(27310);
;// CONCATENATED MODULE: ./components/handle_title_segment/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./components/handle_title_segment/index.js



const segmentsPath = [
    'questoes-de-concursos',
    'questoes-militares',
    'questoes-da-oab',
    'questoes-do-enem',
    'questoes-de-vestibular'
];
const segmentsName = {
    'questoes-de-concursos': 'Concursos',
    'questoes-militares': 'Militares',
    'questoes-da-oab': 'OAB',
    'questoes-do-enem': 'ENEM',
    'questoes-de-vestibular': 'Vestibular'
};
class HandleTitleSegment {
    init() {
        this.activateSegmentButton();
        this.addClickEventToButtons();
        this.redirectToSegment();
        this.toggleModal();
    }
    toggleModal() {
        this.$toogleModalButtons.on('click', ()=>{
            if (this.$modal.hasClass('hidden')) {
                this.openModal();
                return;
            }
            this.closeModal();
        });
    }
    openModal() {
        this.$modal.removeClass('hidden');
        window.jQuery('body').addClass('q-select-no-scroll');
    }
    closeModal() {
        this.$modal.addClass('hidden');
        this.setToInitialSegment();
        window.jQuery('body').removeClass('q-select-no-scroll');
    }
    setBaseUrl() {
        const url = new URL(window.location.href);
        return url.origin;
    }
    hasSegment() {
        const url = new URL(window.location.href);
        const segment = url.pathname.split('/')[1];
        if (segmentsPath.includes(segment)) {
            return segment;
        } else {
            return null;
        }
    }
    pathnameWithoutSegment() {
        const url = new URL(window.location.href);
        const pathParts = url.pathname.split('/').filter((part)=>part && !segmentsPath.includes(part));
        return '/' + pathParts.join('/');
    }
    activateSegmentButton() {
        this.$buttons.each((i, button)=>{
            const $button = window.jQuery(button);
            if ($button.data('segment') === this.dynamicSegment) {
                $button.addClass('active');
            } else {
                $button.removeClass('active');
            }
        });
    }
    addClickEventToButtons() {
        this.$buttons.on('click', (event)=>{
            const $button = window.jQuery(event.target);
            const segment = $button.data('segment');
            this.handleButtonClick(segment);
        });
    }
    setToInitialSegment() {
        if (this.initialSegment === this.dynamicSegment) {
            return;
        }
        this.dynamicSegment = this.initialSegment;
        this.activateSegmentButton();
    }
    handleButtonClick(segment) {
        if (segment === this.dynamicSegment) {
            return;
        }
        this.dynamicSegment = segment;
        this.activateSegmentButton();
    }
    redirectToSegment() {
        const url = new URL(window.location.href);
        const urlSegment = url.pathname.split('/')[1];
        this.$submitButton.on('click', ()=>{
            if (this.dynamicSegment === urlSegment) {
                this.$modal.addClass('hidden');
            } else {
                const url = `${this.baseUrl}/${this.dynamicSegment}${this._pathnameWithoutSegment}`;
                this.trackEvents();
                Turbolinks.visit(url);
            }
        });
    }
    trackEvents() {
        UserTracker.emit('event', {
            eventName: 'study segment changed',
            data: {
                'initial segment': segmentsName[this.initialSegment],
                'final segment': segmentsName[this.dynamicSegment]
            }
        });
    }
    constructor(component){
        this.baseUrl = this.setBaseUrl();
        this.initialSegment = this.hasSegment();
        this.dynamicSegment = this.hasSegment();
        this._pathnameWithoutSegment = this.pathnameWithoutSegment();
        this.component = component;
        this.$buttons = window.jQuery('#buttons-container button');
        this.$toogleModalButtons = window.jQuery('.js-toggle-modal');
        this.$submitButton = window.jQuery('#submit-button');
        this.$modal = window.jQuery('#js-handle-segment-modal');
        this.$segmentTitle = window.jQuery('#segment-title');
        this.init();
    }
}
const $components = window.jQuery('.js-handle-title-segment');
$components.each((i, component)=>new HandleTitleSegment(component));

;// CONCATENATED MODULE: ./styles/components/_alerts.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./styles/components/_pagination.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./pages/disciplines/index.js










;// CONCATENATED MODULE: ./packs/disciplines.js



/***/ }),

/***/ 28925:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": () => (/* binding */ MediaQuery)
/* harmony export */ });
window.screenBreakpoints = {
    xs: 'screen and (max-width:768px)',
    sm: 'screen and (min-width:768px)',
    lt_sm: 'screen and (max-width:768px)',
    md: 'screen and (min-width:992px)',
    lt_md: 'screen and (max-width:992px)',
    lg: 'screen and (min-width:1200px)',
    lt_lg: 'screen and (max-width:1200px)',
    header_lg_breakpoint: 'screen and (min-width:1024px)',
    lt_header_lg_breakpoint: 'screen and (max-width:1024px)'
};
class MediaQuery {
    static match(query) {
        return window.matchMedia ? window.matchMedia(query).matches : true;
    }
    static is(size) {
        return MediaQuery.match(window.screenBreakpoints[size]);
    }
}
window.MediaQuery = MediaQuery;


/***/ }),

/***/ 33617:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var root = __webpack_require__(53235);
/** Built-in value references. */ var Symbol = root.Symbol;
module.exports = Symbol;


/***/ }),

/***/ 94292:
/***/ ((module) => {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length){
        result[index] = iteratee(array[index], index, array);
    }
    return result;
}
module.exports = arrayMap;


/***/ }),

/***/ 48814:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Symbol = __webpack_require__(33617), getRawTag = __webpack_require__(83817), objectToString = __webpack_require__(22552);
/** `Object#toString` result references. */ var nullTag = '[object Null]', undefinedTag = '[object Undefined]';
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
    }
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
module.exports = baseGetTag;


/***/ }),

/***/ 75476:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Symbol = __webpack_require__(33617), arrayMap = __webpack_require__(94292), isArray = __webpack_require__(8388), isSymbol = __webpack_require__(92348);
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') {
        return value;
    }
    if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
    }
    if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
    }
    var result = value + '';
    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}
module.exports = baseToString;


/***/ }),

/***/ 73479:
/***/ ((module) => {

/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof (self || window) == 'object' && (self || window) && (self || window).Object === Object && (self || window);
module.exports = freeGlobal;


/***/ }),

/***/ 83817:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Symbol = __webpack_require__(33617);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) {
            value[symToStringTag] = tag;
        } else {
            delete value[symToStringTag];
        }
    }
    return result;
}
module.exports = getRawTag;


/***/ }),

/***/ 22552:
/***/ ((module) => {

/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
module.exports = objectToString;


/***/ }),

/***/ 53235:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var freeGlobal = __webpack_require__(73479);
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
module.exports = root;


/***/ }),

/***/ 8388:
/***/ ((module) => {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
module.exports = isArray;


/***/ }),

/***/ 96989:
/***/ ((module) => {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = isObjectLike;


/***/ }),

/***/ 92348:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseGetTag = __webpack_require__(48814), isObjectLike = __webpack_require__(96989);
/** `Object#toString` result references. */ var symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
}
module.exports = isSymbol;


/***/ }),

/***/ 36561:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseToString = __webpack_require__(75476);
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function toString(value) {
    return value == null ? '' : baseToString(value);
}
module.exports = toString;


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	(() => {
/******/ 		__webpack_require__.nmd = (module) => {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			1750: 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkIds[i]] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunk"] = self["webpackChunk"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, [5280,1106,9187,6325], () => (__webpack_require__(16020)))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;